import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

/**
 * Dummy-Component for the table refresh problem workaround
 */
@Component({
  selector: 'sps-table-refresh-workaround',
  imports: [],
  template: '',
})
export class TableRefreshWorkaroundComponent implements OnInit {

  router = inject(Router);
  route = inject(ActivatedRoute);

  ngOnInit() {
    sessionStorage.removeItem('ADMIN_ONBOARDING_VIEW');
    sessionStorage.removeItem('ADMIN_ORGANISATIONS_VIEW');
    this.router.navigate([this.route.snapshot.paramMap.get('redirect')]);
  }
}
